export default __webpack_public_path__ + "static/media/default-report.c9af132b.svg";